var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMomentumSpikesSurge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.66 3.22a1.286 1.286 0 011.786.345l6.483 9.585a1.286 1.286 0 11-2.13 1.44l-4.744-7.013-4.65 24.095c-.088.456-.415.83-.855.976L7.693 36.934a1.286 1.286 0 01-.814-2.44l12.144-4.048L23.531 7.09l-7.014 4.744a1.286 1.286 0 11-1.44-2.13l9.584-6.483z"
  })));
}
export default SvgMomentumSpikesSurge;